import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {
  isChecked: boolean = false;
  constructor(private router: Router) {;
  }

  ngOnInit() {
  }
  onSubmit(): void {
    if (this.isChecked) {
      this.router.navigate(['/register']);
    }
  }
  
}




// WEBPACK FOOTER //
// ./src/app/registration/terms-condition/terms-condition.component.ts